<template lang="pug">
modal(name="dialog", height="auto", :classes="['v--modal', 'vue-dialog', this.params.class]", :width="width", :pivot-y="0.3", :adaptive="true", :clickToClose="clickToClose", :transition="transition", @before-open="beforeOpened", @before-close="beforeClosed", @opened="opened", @closed="closed")
  .dialog-content(:class="params.showInput ? 'flex' : ''")
    .dialog-c-title(v-if="params.title", v-html="params.title || ''")
    component(v-if="params.component", v-bind="params.props", :is="params.component")
    .dialog-c-text(v-else, v-html="params.text || ''")
    .dialog-c-input-title.collapsible-title(v-if="params.input_title" :class="textareaVisible ? 'active' : ''"  @click="toggleTextarea")
      span(v-html="params.input_title || ''")
      span(class="arrow-icon") ▼
    transition(name="expand")
      .vue-dialog-textarea(v-show="params.showInput && textareaVisible" class="textarea-container" :class="textareaVisible ? 'opened' : 'closed'")
        textarea.vue-dialog-input.dialog-textarea(type="text", v-model="inputValue", :maxlength="params.inputMaxLength", :class="{'textarea-warning': charsRemaining <= warningThreshold}", @keydown.enter.stop, :placeholder="params.placeholder ? params.placeholder : 'Enter your response'")
        .char-count(v-if="params.showInput") {{ charsRemaining }} characters remaining
    .dialog-c-text(v-if="params.text2", v-html="params.text2 || ''")
  .vue-dialog-buttons(v-if="buttons")
    button(v-for="(button, i) in buttons", :class="button.class || 'vue-dialog-button'", ref="buttons", :id="'button-dialog-' + i", type="button", :style="buttonStyle", :key="i", v-html="button.title", @click.stop="click(i, $event)")
  .vue-dialog-buttons-none(v-else)
</template>
<script>
  export default {
      name: 'VueJsDialog',
      props: {
          width: {
              type: [Number, String],
              default: 400
          },
          clickToClose: {
              type: Boolean,
              default: true
          },
          transition: {
              type: String,
              default: 'fade'
          }
      },
      data() {
          return {
              params: {},
              // A caller's onClosed, armed on 'opened' — see there.
              closedHook: null,
              textareaVisible: false,
              inputValue: '',
              defaultButtons: [{
                  title: 'CLOSE'
              }]
          }
      },
      computed: {
          charsRemaining() {
              const maxLength = this.params.inputMaxLength || 0;
              return maxLength - this.inputValue.length;
          },
          warningThreshold() {
              // Show warning when remaining chars drop below 10% of max length (adjust as needed)
              return (this.params.inputMaxLength || 0) * 0.1;
          },
          buttons() {
              return this.params.buttons || this.defaultButtons
          },
          /**
           * Returns FLEX style with correct width for arbitrary number of
           * buttons.
           */
          buttonStyle() {
              return {
                  flex: `1 1 ${100 / this.buttons.length}%`
              }
          }
      },
      methods: {
          beforeOpened(event) {
              window.addEventListener('keyup', this.onKeyUp)

              this.params = event.params || {}
              this.textareaVisible = !!this.params.inputInitiallyOpen;
              this.inputValue = '';
              this.$emit('before-opened', event)
          },
          beforeClosed(event) {
              // Paired with the add in beforeOpened: a dialog that hides and
              // re-shows itself sees before-close, before-open, then the old
              // 'closed', so removing there would strip the new dialog's
              // listener. `params` deliberately stay put — the box is still
              // patched from them until the modal's own render unmounts it,
              // and clearing them here blanks the text under the fade-out.
              window.removeEventListener('keyup', this.onKeyUp)
              this.$emit('before-closed', event)
          },
          toggleTextarea() {
              this.textareaVisible = !this.textareaVisible;
              console.log('textareaVisible', this.textareaVisible);
          },
          /**
           * Lifecycle hooks a caller may pass in params, as with the
           * other modals: onOpened for attaching handlers to HTML the
           * dialog rendered (the tree's "which family?" chooser),
           * onClosed so a caller awaiting an answer learns the dialog
           * went away without one — overlay click, Escape. The close
           * hook is armed here rather than at before-open so the
           * 'closed' of a dialog this one replaced cannot fire it.
           */
          opened(event) {
              this.closedHook = typeof this.params.onClosed === 'function' ? this.params.onClosed : null
              if (typeof this.params.onOpened === 'function') this.params.onOpened(event)
              this.$emit('opened', event)
          },
          closed(event) {
              const hook = this.closedHook
              this.closedHook = null
              this.$emit('closed', event)
              if (hook) hook(event)
          },
          click(i, event, source = 'click') {
              const button = this.buttons[i]

              if (button && typeof button.handler === 'function') {
                  button.handler(i, event, {
                      source,
                      inputValue: this.inputValue
                  });
              } else {
                  this.$modal.hide('dialog')
              }
          },
          onKeyUp(event) {
              if (event.target && event.target.tagName === 'TEXTAREA') {
                  event.stopPropagation();
                  return;
              }
              if (event.which === 13 && this.buttons.length > 0) {
                  const buttonIndex =
                      this.buttons.length === 1 ?
                      0 :
                      this.buttons.findIndex(button => button.default)

                  if (buttonIndex !== -1) {
                      this.click(buttonIndex, event, 'keypress')
                  }
              }
          }
      }
  }
</script>
<style>
  .vue-dialog div {
    box-sizing: border-box;
  }

  .vue-dialog .dialog-flex {
    width: 100%;
    height: 100%;
  }

  .vue-dialog .dialog-content {
    flex: 1 0 auto;
    width: 100%;
    padding: 15px;
    font-size: 14px;
  }

  .vue-dialog .dialog-c-title {
    font-weight: 600;
    padding-bottom: 15px;
  }

  .vue-dialog .dialog-c-text {}

  .vue-dialog .vue-dialog-buttons {
    display: flex;
    flex: 0 1 auto;
    width: 100%;
    border-top: 1px solid #eee;
  }

  .vue-dialog .vue-dialog-buttons-none {
    width: 100%;
    padding-bottom: 15px;
  }

  .vue-dialog-button {
    font-size: 12px !important;
    background: transparent;
    padding: 0;
    margin: 0;
    border: 0;
    cursor: pointer;
    box-sizing: border-box;
    line-height: 40px;
    height: 40px;
    color: inherit;
    font: inherit;
    outline: none;
  }

  .vue-dialog-button:hover {
    background: rgba(0, 0, 0, 0.01);
  }

  .vue-dialog-button:active {
    background: rgba(0, 0, 0, 0.025);
  }

  .vue-dialog-button:not(:first-of-type) {
    border-left: 1px solid #eee;
  }

  .vue-dialog-input {
    width: 100%;
    padding: 8px;
    margin-top: 2px;
    margin-bottom: 10px;
    min-height: 100px;
    box-sizing: border-box;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    transition: background-color 0.3s ease;
  }

  .dialog-c-input-title {
    text-align: center;
    margin: auto;
    margin-top: 10px;
    margin-bottom: 5px;
    text-transform: uppercase;
    display: inline-block;
    padding: 0 5px 3px 5px;
    font-weight: 700;
    font-size: 0.7em;
    color: #47f1fd;
    color: #fff;
    color: #6af5ff;
    font-family: 'Montserrat', Arial, Serif;
    opacity: 1;
  }

  body #app .v--modal-overlay .textarea-warning {
    background-color: #e5b8b8;
  }

  .char-count {
    font-size: 12px;
    color: silver;
    text-align: center;
    margin-top: -8px;
    margin-bottom: 4px;
  }

  .collapsible-title {
    cursor: pointer;
    user-select: none;
    position: relative;
  }

  .arrow-icon {
    display: inline-block;
    transition: transform 0.3s ease;
    color: #999;
    font-size: 1.2em;
    margin-left: 4px;
  }

  /* Rotate arrow when active */
  .collapsible-title.active .arrow-icon {
    transform: rotate(180deg);
    /* Rotates from ▼ to ▲ */
  }

  .noicon .arrow-icon {
    display: none;
  }

  .expand-enter-active,
  .expand-leave-active {
    transition: max-height 0.3s ease;
    overflow: hidden;
  }

  .expand-enter,
  .expand-leave-to {
    max-height: 0;
    opacity: 0;
  }

  .expand-enter-to,
  .expand-leave {
    max-height: 200px;
    /* generous max height */
    opacity: 1;
  }

  .dialog-content.flex {
    text-align: center;
  }
</style>
